// @ts-nocheck
import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block";
import Typography, { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import { orderProps } from "@store/Themes/common/props/order";
import constants from "@store/constants";
import { loadingDotsStyles } from "@store/Themes/common/mixins/typography";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface ReturnRequestHeaderStyles {
    block?: BlockProps;
    invoiceNumberLoadingText?: TypographyPresentationProps;
    invoiceNumberHeading?: TypographyPresentationProps;
}

export const returnRequestHeader: ReturnRequestHeaderStyles = {
    block: orderProps.block,
    invoiceNumberLoadingText: {
        ...orderProps.subtitle,
        css: css`
            ${loadingDotsStyles()}
            font-weight: ${x => x.theme.design.typography.weight.base};
        `,
    },
    invoiceNumberHeading: orderProps.subtitle,
};

const styles = returnRequestHeader;

const ReturnRequestHeader = (props: Props) => {
    const { value: invoice, isLoading } = useContext(InvoiceStateContext);
    const { invoiceNumber } = useQueryString();

    return (
        <Block {...styles.block} data-test-selector="returnRequest_header">
            <Typography
                {...(isLoading ? styles.invoiceNumberLoadingText : styles.invoiceNumberHeading)}
                data-test-selector="returnRequest_invoiceNumber"
            >
                {(!invoice && isLoading) || invoice
                    ? `${translate("Invoice #")}${(invoice && invoice.invoiceNumber) || ""}`
                    : invoiceNumber
                      ? translate("Could not retrieve invoice information for invoice #{0}", invoiceNumber)
                      : translate("Could not retrieve invoice information")}
            </Typography>
        </Block>
    );
};

const widgetModule: WidgetModule = {
    component: ReturnRequestHeader,
    definition: {
        group: constants.widgetGroup.returnRequest,
        allowedContexts: [constants.pageType.returnRequestRmaPage],
        displayName: "Return Request Header",
    },
};

export default widgetModule;
